import styled from 'styled-components';
import { layout } from 'styles/layout';
import { palette } from 'styles/colors';

export const ProTextInputWrapper = styled.div`
  flex-direction: column;
  margin-top: 32px;
  padding-right: 16px;
  width: 100%;
`;

export const HiddenInput = styled.input`
  display: none;
`

export const StyledLabel = styled.label`
  display: block;
  box-sizing: border-box;
  font-weight: 300;
  line-height: 1.3;
  clear: both;
  font-size: 18px;
  margin-bottom: 16px;

  @media screen and (min-width: ${layout.sm}) {
    font-size: 22px;
  }
`;

export const StyledInput = styled.input`
  border: 2px solid ${palette.steelTeal};
  font-size: 16px;
  width: 100%;
  margin: 0;
  outline: 0;
  padding: 16px;
  color: ${palette.footerBackground};
  border-radius: 4px;
  height: 58px;
  max-height: 58px;
  transition: all .3s ease-in-out;
  box-sizing: border-box;
  font-weight: 300;
  font-family: Lato, sans-serif;

  @media screen and (min-width: ${layout.sm}) {
    font-size: 18px;
    padding: 24px;
    height: 68px;
    max-height: 68px;
  }
`;

export const RequiredAsteriskWrapper = styled.span`
  color: ${palette.proBlue};
  margin-left: 4px;
`;

export const RequiredHelpText = styled.p`
  color: ${palette.proBlue};
  text-align: center;
`;
